var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
const SvgReset = props => /*#__PURE__*/React.createElement("svg", _extends({
  width: 21,
  height: 20,
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
  stroke: "#C94937",
  strokeWidth: 1.6,
  strokeMiterlimit: 10
}, /*#__PURE__*/React.createElement("path", {
  d: "M10.375 1.625c-.875 0-1.5.625-1.5 1.5V8c0 .125-.125.25-.25.25H3.25c-.125 0-.25.125-.125.375l1 3.25V12L3 17.25c0 .125.125.25.25.25h14.5c.125 0 .25-.125.25-.25L16.875 12v-.125L18 8.625c0-.125-.125-.375-.25-.375h-5.5A.269.269 0 0 1 12 8V3.125c0-.875-.75-1.5-1.625-1.5ZM4.125 11.875h12.75"
}), /*#__PURE__*/React.createElement("path", {
  d: "M10.5 17.5v-2.875M13.375 17.5v-1.625M7.625 17.5v-1.625",
  strokeLinecap: "round"
}))));
export default SvgReset;